import { deleteRequest, get, post } from './_defaults/fetch.js';

export const getDocuments = async ({params, config}) => get('/documents', {params, ...config});
export const getDocument = async ({id, params, config}) => get(`/documents/${id}`, {params, ...config});
export const verifyPublicFile = async ({data, config}) => {
    const formData = new FormData();
    for (const key in data) {
        formData.append(key, data[key]);
    }
    return await post('/documents/verify', formData, config);
};
export const verifyPublicFiles = async ({data, config}) => {
    let responses = [];
    const { files, ...rest } = data;
    for (const file of files) {
        const response = await verifyPublicFile({
            data: {
                ...rest,
                file
            },
            config
        });
        responses.push(response);
    }
    return responses;
};